<ng-content></ng-content>
<dialog #dialog (click)="closeZoom(); $event.stopPropagation()">
  <kb-picture [picture]="picture" [variants]="originalVariants" [alt]="alt" [rootColumns]="12"></kb-picture>
</dialog>
